angular.module('unergie.main')
.directive('userInfoContract', ($timeout, BoFeaturesService, MetaWatcher, DataAccess, AlertManager, DataAccessRefPromo, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContract.html',
        link($scope) {
            $scope.draftIndexShift = 10000
            $scope.activeIndex = null
            $scope.contratsTab = {}
            $scope.canSeeJira = BoFeaturesService.get('canSeeJira')
            $scope.selectedContract = undefined

            $scope.isCFeatureOn = (feature) => BoFeaturesService.getModuleFeatures('contracts')[feature]

            const updateContract = (contract) => {
                $scope.selectedContract = contract
                $scope.refreshTab()
                $scope.updateContract(contract)
            }

            $scope.onContractSelected = (contract, event) => {
                if (event) { // on ne rafraichi qu'au click utilisateur
                    updateContract(contract)
                }
            }

            const finalizeLoading = () => {
                $timeout(() => {
                    $scope.activeIndex = $scope.state.contractTabIndex
                    _.assign($scope.contratsTab, _.get($scope, 'account.contractList'))
                    $scope.refreshTabDone()
                })
            }

            $scope.$watch('state.rootView.loadingContract', (loadingContract) => {
                if (loadingContract.isLoading === false) {
                    finalizeLoading()
                }
            })
            $scope.$watch('state.rootView.loadingContractDraft', (loadingContractDraft) => {
                if (loadingContractDraft === false) {
                    finalizeLoading()
                }
            })

            $scope.$watch('state.account', () => {
                $scope.activeIndex = null
                return $timeout(() => {
                    $scope.nbContracts = $scope.state.account.contractList.length
                    $scope.activeIndex = $scope.state.contractTabIndex
                    _.assign($scope.contratsTab, _.get($scope, 'account.contractList'))
                })
            })

            $scope.getPromoDetailsForPopup = (id_ref_promo) => {
                return DataAccessRefPromo.getPromo({ id: id_ref_promo }).$promise.then((promoResult) => {
                    const promo = promoResult.toJSON()
                    let html = `<h4>Code : ${promo.id}</h4><div>`
                    switch (promo.retribution_type) {
                        case 'pot':
                            html += `Cagnotte : ${promo.retribution_amount} €</div>`
                            break
                        case 'offer':
                            html += `Offre : ${promo.offer_id}</div>`
                            break
                        case 'annual-pot':
                            html += `Cagnotte annuelle : ${promo.retribution_amount} € / an</div>`
                            if (promo.custom_checks.maxAnnualPotDurationDays) {
                                const years = (promo.custom_checks.maxAnnualPotDurationDays / 365).toFixed(0)
                                html += `Pendant : ${years} an${years > 1 ? 's' : ''}</div>`
                            }
                            break
                        default:
                    }
                    if (promo.ambassador_customer_id) {
                        html += `<div>Ambassadeur : ${promo.ambassador_customer_id} (${promo.ambassador_retribution_amount} €)</div>`
                    }
                    return html
                })
                .catch(ErrorCatcher)
            }

            $scope.addPromoTemplate = {
                id_ref_promo: null,
            }

            $scope.addPromoFields = {
                id_ref_promo: {
                    label: 'Code promotionnel',
                    type: 'select',
                    required: true,
                    enum: [],
                },
            }

            $scope.fetchAvailablePromos = () => {
                $scope.addPromoTemplate.id_ref_promo = null
                return DataAccessRefPromo.getPromos({ retribution_type: 'annual-pot' }).$promise
                .then((promos) => {
                    $scope.addPromoFields.id_ref_promo.enum = _.map(_.orderBy(promos, 'id'), (promo) => ({ label: promo.id, value: promo.id }))
                })
                .catch(ErrorCatcher)
            }

            $scope.addPromoOnContract = () => {
                return DataAccessRefPromo.addPromoOnContract({ id_contract: $scope.selectedContract.id }, $scope.addPromoTemplate).$promise
                .then(() => {
                    AlertManager.success('Code promo ajouté')
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.selectedContract)
                })
                .catch(ErrorCatcher)
            }

            MetaWatcher.watch('CONTRACT_CHANGED', 'userInfoContract', $scope, updateContract)
            MetaWatcher.watch('PAYMENT_CHANGED', 'userInfoContract', $scope, updateContract)
        },
    })
)
